import { Box, Button, Container, Typography } from "@mui/material"
import { CSSProperties } from "react";
import { FiPlus } from "react-icons/fi"

import ListPost from "./components/list";
import { useNavigate } from "react-router-dom";

const PainelControlePage = () => {

    const navigate = useNavigate();    
    const sxMain: CSSProperties = {
        width: "100%",
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "space-between",
        alignContent: "center",
        border: "1px solid #dddddd"
    }
    const sxMainSub: CSSProperties = {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflowY: "auto",
        maxHeight: "80vh"
    }

    return (
        <Box>
            <Container sx={{ }}>
                <Typography variant="h6" align="center">
                    Painel de Controle
                </Typography>
                <Box sx={sxMain}>
                    <Box sx={sxMainSub} >
                        <Box 
                            bgcolor="#f3f3f3"
                            position="sticky" 
                            top={0} 
                            width="100%" 
                            zIndex={1} 
                            boxShadow="0 0.1em 1em #676767"
                            padding="0.5em 0"
                            display="flex"
                            justifyContent="space-evenly"
                            alignItems="center"
                        >
                            {/* <Button variant="contained" color="secondary" startIcon={<FiPlus />} onClick={() => navigate("/blog/new")}>Nova tag</Button> */}
                            <Button variant="contained" color="warning" startIcon={<FiPlus />} onClick={() => navigate("/blog/new")}>Nova postagem</Button>
                            <Typography variant="body1">
                                Lista de Postagem
                            </Typography>
                        </Box>
                        <Box>
                            <ListPost/>
                        </Box>
                    </Box>
                    <Box sx={sxMainSub} bgcolor={"#e3e3e3"}>

                    </Box>
                </Box>
            </Container>
        </Box>
    )
}


export default PainelControlePage